export const LIVE_ESCAPE_ROOM_GET = 'LIVE_ESCAPE_ROOM_GET';
export const LIVE_ESCAPE_ROOM_UPDATE = 'LIVE_ESCAPE_ROOM_UPDATE';
export const ON_LIVE_ESCAPE_ROOM_UPDATED = 'ON_LIVE_ESCAPE_ROOM_UPDATED';